// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3TW6H","icon":"SortAdornment_icon__3lEk_","up":"SortAdornment_up__2yFDV","down":"SortAdornment_down__2jojn","active":"SortAdornment_active__1xwbd"};